import { Check, X } from 'lucide-react';

import { Button } from '@/modules/ui/components/button/Button';
import { Textarea } from '@/modules/ui/components/textarea/Textarea';

interface EditableMessageProps {
  content: string;
  isPending: boolean;
  onChange: (content: string) => void;
  onSave: () => void;
  onCancel: () => void;
}

export const EditableMessage = ({
  content,
  isPending,
  onChange,
  onSave,
  onCancel,
}: EditableMessageProps) => {
  return (
    <div className="flex flex-col gap-2">
      <Textarea
        value={content}
        onChange={(e) => onChange(e.target.value)}
        rows={3}
      />
      <div className="flex gap-2">
        <Button
          size="sm"
          variant="primary"
          onClick={onSave}
          loading={isPending}
        >
          <Check size={14} />
          Save
        </Button>
        <Button size="sm" variant="outline" onClick={onCancel}>
          <X size={14} />
          Cancel
        </Button>
      </div>
    </div>
  );
};
